import axiosInstance from "../api/axios";

export const fetchMyPermissions = async () => {
  const response = await axiosInstance.get("/me/permissions");
  return response;
};

export const fetchPermissions = async () => {
  return axiosInstance.get("/permissions");
};

export const fetchRoles = async () => {
  return axiosInstance.get("/roles");
};

export const createRole = async ({ name, permissionCodes }) => {
  return axiosInstance.post("/roles", { name, permissionCodes });
};

export const updateRole = async (roleId, payload) => {
  return axiosInstance.patch(`/roles/${roleId}`, payload);
};

export const deleteRole = async (roleId) => {
  return axiosInstance.delete(`/roles/${roleId}`);
};

export const fetchRoleAssignments = async ({ loginId, projectId } = {}) => {
  return axiosInstance.get("/role-assignments", {
    params: { loginId, projectId },
  });
};

export const createRoleAssignment = async ({ loginId, rbacRoleId, projectId }) => {
  return axiosInstance.post("/role-assignments", {
    loginId,
    rbacRoleId,
    projectId,
  });
};

export const createRoleAssignmentsBulk = async ({ loginId, rbacRoleId, projectIds }) => {
  return axiosInstance.post("/role-assignments/bulk", {
    loginId,
    rbacRoleId,
    projectIds,
  });
};

export const deleteRoleAssignment = async (assignmentId) => {
  return axiosInstance.delete(`/role-assignments/${assignmentId}`);
};
